import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  DialogActions,
} from '@mui/material';
import { differenceInCalendarDays, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function RenewPlanWarning({ open, currentPlanInfo, onClose, onRenew }) {
  const { t } = useTranslation();

  if (!open || !currentPlanInfo?.expire_date) return null;

  const endDate = parseISO(currentPlanInfo.expire_date);
  const daysLeft = differenceInCalendarDays(endDate, new Date());
  const isTrial = currentPlanInfo?.has_trial_period ?? false;

  const title = t('renew_plan_warning.plan_expiry_warning');

  const message =
    daysLeft === 0
      ? t(`renew_plan_warning.expires_today_${isTrial ? 'trial' : 'normal'}`)
      : t(
          `renew_plan_warning.expires_in_days_${isTrial ? 'trial' : 'normal'}`,
          { count: daysLeft }
        );

  const actionButtonText = isTrial
    ? t('renew_plan_warning.upgrade_to_paid')
    : t('renew_plan_warning.renew_or_upgrade');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <WarningAmberIcon color="warning" fontSize="large" />
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>

      <DialogContent>
        <Box>
          <Typography variant="body1">{message}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
            {t('renew_plan_warning.renew_to_avoid_interruption')}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="error">
          {t('renew_plan_warning.remind_me_later')}
        </Button>

        <Button
          variant="contained"
          onClick={() => {
            onRenew();
            onClose();
          }}
        >
          {actionButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
